import { useCallback, useEffect, useRef, useState } from 'react';

// Busca independente de uma seção do relatório (KPIs, gráfico, ranking...).
// Cada seção tem seu próprio loading/erro/reload, então a falha de uma
// requisição não derruba as demais seções já carregadas com sucesso.
export function useReportSection(fetcher, deps = []) {
  const fetcherRef = useRef(fetcher);
  fetcherRef.current = fetcher;

  const [data, setData] = useState(null);
  const [meta, setMeta] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [reloadKey, setReloadKey] = useState(0);
  const requestId = useRef(0);

  useEffect(() => {
    const currentRequest = ++requestId.current;
    setLoading(true);
    setError(false);

    Promise.resolve(fetcherRef.current())
      .then(result => {
        if (currentRequest !== requestId.current) return;
        if (result?.error) {
          setError(result.error);
          setData(null);
          setMeta(null);
        } else {
          setData(result?.data ?? null);
          setMeta(result?.meta ?? null);
        }
      })
      .catch(error => {
        if (currentRequest !== requestId.current) return;
        setError(error || true);
        setData(null);
        setMeta(null);
      })
      .finally(() => {
        if (currentRequest !== requestId.current) return;
        setLoading(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...deps, reloadKey]);

  const reload = useCallback(() => setReloadKey(key => key + 1), []);

  return { data, meta, loading, error, reload };
}
